import React from "react";
import icons from "Common/Icons";
import "./Styles/SomethingWentWrong.scss";

export default class extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    handleRefesh() {
        typeof this.props.handleRefresh == "function" && this.props.handleRefresh();
    }

    render() {
        return (
            <div className="something-went-wrong-wrapper">
                <div className="something-went-wrong-container">
                    <img src={icons.information}/>
                    <div>Something went wrong. Please try again.</div>
                    <div onClick={this.handleRefesh.bind(this)}><img src={icons.reload}/> Tap to Retry</div>
                </div>
            </div>
        )
    }
}